import { LinearProgress } from '@mui/material';
import React from 'react';
import { Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const PrivateSalesExportModal: React.FC = () => {
  const { privateSalesExportPercentage, privateSalesExportModalIsOpen } =
    useSelector((state) => state.privateSalesListReducer);

  return (
    <Modal
      open={privateSalesExportModalIsOpen}
      onClose={() => {}}
      title='Preparando exportação'
      noCloseButton
    >
      <LinearProgress
        variant='determinate'
        value={privateSalesExportPercentage}
        sx={{ height: '20px', borderRadius: '40px' }}
      />
    </Modal>
  );
};
